webpackJsonp([19],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    disabled: Boolean
  }
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isString */
/* unused harmony export isNumber */
/* unused harmony export isRegExp */
/* unused harmony export isBool */
/* unused harmony export isDate */
/* harmony export (immutable) */ __webpack_exports__["a"] = isArray;
/* harmony export (immutable) */ __webpack_exports__["b"] = isObject;
/* unused harmony export isFunction */
/* harmony export (immutable) */ __webpack_exports__["c"] = merge;
/* harmony export (immutable) */ __webpack_exports__["d"] = rangeArray;
var STRING_PROTOTYPE = '[object String]';
var NUMBER_PROTOTYPE = '[object Number]';
var REGEXP_PROTOTYPE = '[object RegExp]';
var DATE_PROTOTYPE = '[object Date]';
var BOOL_PROTOTYPE = '[object Boolean]';
var ARRAY_PROTOTYPE = '[object Array]';
var OBJECT_PROTOTYPE = '[object Object]';
var FUNCTION_PROTOTYPE = '[object Function]';

function protoString(obj) {
  return Object.prototype.toString.call(obj);
}

function isString(str) {
  return protoString(str) === STRING_PROTOTYPE;
}

function isNumber(num) {
  return protoString(num) === NUMBER_PROTOTYPE;
}

function isRegExp(reg) {
  return protoString(reg) === REGEXP_PROTOTYPE;
}

function isBool(bool) {
  return protoString(bool) === BOOL_PROTOTYPE;
}

function isDate(date) {
  return protoString(date) === DATE_PROTOTYPE;
}

function isArray(arr) {
  return protoString(arr) === ARRAY_PROTOTYPE;
}

function isObject(obj) {
  return protoString(obj) === OBJECT_PROTOTYPE;
}

function isFunction(fn) {
  return protoString(fn) === FUNCTION_PROTOTYPE;
}

/**
 * Vue data merge
 * @param  {Object} to      object that want to be merget to
 * @param  {Object} origins origin object sources
 */
function merge(to) {
  for (var _len = arguments.length, origins = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    origins[_key - 1] = arguments[_key];
  }

  origins.forEach(function (from) {
    for (var key in from) {
      var value = from[key];
      // Just merge existed property in origin data
      if (to[key] !== undefined) {
        switch (protoString(value)) {
          case OBJECT_PROTOTYPE:
            merge(to[key], value);
            break;
          default:
            to[key] = value;
            break;
        }
      }
    }
  });
}

function rangeArray(start, end) {
  var array = [];
  for (var i = start; i <= end; i++) {
    array.push(i);
  }
  return array;
}

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var HANDLER = '_vue_clickoutside_handler';

function bind(el, binding) {
  unbind(el);

  var callback = binding.value;

  // @NOTE: Vue binds directives in microtasks, while UI events are dispatched
  //        in macrotasks. This causes the listener to be set up before
  //        the "origin" click event (the event that lead to the binding of
  //        the directive) arrives at the document root. To work around that,
  //        we ignore events until the end of the "initial" macrotask.
  // @REFERENCE: https://jakearchibald.com/2015/tasks-microtasks-queues-and-schedules/
  // @REFERENCE: https://github.com/simplesmiler/vue-clickaway/issues/8
  var initialMacrotaskEnded = false;
  setTimeout(function () {
    initialMacrotaskEnded = true;
  }, 0);

  el[HANDLER] = function (ev) {
    // @NOTE: IE 5.0+
    // @REFERENCE: https://developer.mozilla.org/en/docs/Web/API/Node/contains
    if (initialMacrotaskEnded && !el.contains(ev.target)) {
      return callback(ev);
    }
  };

  document.documentElement.addEventListener('click', el[HANDLER], false);
}

function unbind(el) {
  document.documentElement.removeEventListener('click', el[HANDLER], false);
  delete el[HANDLER];
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: bind,
  update: function update(el, binding) {
    if (binding.value === binding.oldValue) return;
    bind(el, binding);
  },
  unbind: unbind
});

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports) {

module.exports = Vuex;

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ name: 'Alert', link: 'alert' }, { name: 'Badge', link: 'badge' }, { name: 'Breadcrumb', link: 'breadcrumb' }, { name: 'Buttons', link: 'button' }, { name: 'ButtonGroup', link: 'button-group' }, { name: 'Card', link: 'card' }, { name: 'Carousel', link: 'carousel' }, { name: 'Dropdowns', link: 'dropdown' }, { name: 'Jumbotron', link: 'jumbotron' }, { name: 'ListGroup', link: 'list-group' }, { name: 'Modal', link: 'modal' }, { name: 'Navs', link: 'nav' }, { name: 'Navbar', link: 'navbar' }, { name: 'Pagination', link: 'pagination' }, { name: 'Progress', link: 'progress' }]);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: [String, Number, Object]
  },
  data: function data() {
    return {
      children: [],
      activedIndex: this.value !== undefined ? this.value : -1
    };
  },

  watch: {
    value: function value(v) {
      this.activedIndex = v;
    }
  },
  methods: {
    addChild: function addChild(child) {
      this.children.push(child);
      // if child's name is not set, set child's index as the index of children
      if (!child.name) {
        child.setIndex(this.children.length);
      }
      // set the default activedIndex to the first child's index
      if (this.value === undefined && this.children.length === 1) {
        this.activedIndex = child.index;
      }
    },
    removeChild: function removeChild(child) {
      var index = this.children.indexOf(child);
      this.children.splice(index, 1);
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: [String, Number, Object]
  },
  data: function data() {
    return { index: this.name !== undefined ? this.name : -1 };
  },

  computed: {
    selected: function selected() {
      return this.index === this.$parent.activedIndex;
    }
  },
  methods: {
    setIndex: function setIndex(index) {
      this.index = index;
    }
  },
  created: function created() {
    this.$parent.addChild(this);
  },
  destroyed: function destroyed() {
    this.$parent.removeChild(this);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__register__ = __webpack_require__(107);






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fffc8c14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(91);
function injectStyle (ssrContext) {
  __webpack_require__(55)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fffc8c14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex__);


//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      confirmPromiseResolve: null,
      confirmPromiseReject: null,
      toastQueue: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['toast', 'confirm'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['updateToast', 'updateConfirm']), {
    onConfirmCancel: function onConfirmCancel() {
      if (this.confirmPromiseReject) {
        this.confirmPromiseReject();
        this.updateConfirm({ show: false });
      }
    },
    onConfirmOk: function onConfirmOk() {
      if (this.confirmPromiseResolve) {
        this.confirmPromiseResolve();
        this.updateConfirm({ show: false });
      }
    }
  }),
  created: function created() {
    var self = this;
    // TODO:优化，暂时不支持多toast一起调用 toast方法
    __WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$toast = function (message) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;

      self.updateToast({ show: true, message: message });
      setTimeout(function () {
        self.updateToast({ show: false });
      }, duration);
    };
    // confirm 方法
    __WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$confirm = function (title, content) {
      self.updateConfirm({ show: true, title: title, content: content });
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        self.confirmPromiseResolve = resolve;
        self.confirmPromiseReject = reject;
      });
    };
  }
});

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "router"
    }
  }, [_c('router-view')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_BaseView__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(50);





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router___default.a);

var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_BaseView__["a" /* default */],
  children: [{
    path: '/',
    component: function component(resolve) {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 220)).then(resolve);
    },
    meta: { showNav: true, order: 1 }
  }]
}, {
  path: '/auth',
  component: function component(resolve) {
    return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 221)).then(resolve);
  },
  redirect: '/auth/login',
  children: [{
    path: 'login',
    component: function component(resolve) {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 222)).then(resolve);
    },
    meta: { skipAuth: true, order: 1 }
  }, {
    path: 'register',
    component: function component(resolve) {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 223)).then(resolve);
    },
    meta: { skipAuth: true, order: 2 }
  }]
}];

__WEBPACK_IMPORTED_MODULE_3__components__["a" /* default */].forEach(function (_component) {
  routes[0].children.push({
    path: '/components/' + _component.link,
    component: function component(resolve) {
      return __webpack_require__(103)("./" + _component.name + '.md').then(resolve);
    }
  });
});

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router___default.a({
  mode: 'hash',
  linkActiveClass: 'active',
  routes: routes
});

router.beforeEach(function (to, from, next) {
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = VueRouter;

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseView_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d7020d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_BaseView_vue__ = __webpack_require__(102);
function injectStyle (ssrContext) {
  __webpack_require__(95)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d7020d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_BaseView_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SidebarNav__ = __webpack_require__(97);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SidebarNav: __WEBPACK_IMPORTED_MODULE_0__components_SidebarNav__["a" /* default */]
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNav_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85be27d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNav_vue__ = __webpack_require__(101);
function injectStyle (ssrContext) {
  __webpack_require__(98)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85be27d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNav_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(100);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      navs: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */]
    };
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(50);

/* harmony default export */ __webpack_exports__["a"] = ([{
  group: 'Getting started',
  children: [{ name: 'Introduction', link: 'getting-started/introduction' }, { name: 'Bootstrap', link: 'getting-started/bootstrap' }]
}, {
  group: 'Layout',
  children: [{ name: 'Overview', link: 'layout/overview' }]
}, {
  group: 'Components',
  children: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].map(function (comp) {
    return { name: comp.name, link: '/components/' + comp.link };
  })
}]);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "collapse bd-links",
    attrs: {
      "id": "bd-docs-nav"
    }
  }, _vm._l((_vm.navs), function(group) {
    return _c('div', {
      staticClass: "bd-toc-item",
      class: {
        active: true
      }
    }, [_c('router-link', {
      staticClass: "bd-toc-link",
      attrs: {
        "to": group.children[0].link
      }
    }, [_vm._v(_vm._s(group.group))]), _vm._v(" "), _c('ul', {
      staticClass: "nav bd-sidenav"
    }, _vm._l((group.children), function(li) {
      return _c('router-link', {
        key: li.link,
        attrs: {
          "tag": "li",
          "to": li.link,
          "active-class": "active bd-sidenav-active"
        }
      }, [_c('a', [_vm._v(_vm._s(li.name))])])
    }))], 1)
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('bs-navbar', {
    staticClass: "bd-navbar",
    attrs: {
      "type": "dark"
    }
  }, [_c('template', {
    slot: "brand"
  }, [_vm._v("Bootstrap")]), _vm._v(" "), _c('bs-navbar-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('bs-navbar-item', [_vm._v("Link")]), _vm._v(" "), _c('bs-navbar-item', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled")])], 2), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row flex-xl-nowrap"
  }, [_c('div', {
    staticClass: "col-12 col-md-3 col-xl-2 bd-sidebar"
  }, [_c('sidebar-nav')], 1), _vm._v(" "), _c('main', {
    staticClass: "col-12 col-md-9 col-xl-8 py-md-3 pl-md-5 bd-content"
  }, [_c('router-view')], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Alert.md": [
		205,
		14
	],
	"./Badge.md": [
		206,
		13
	],
	"./Breadcrumb.md": [
		207,
		12
	],
	"./ButtonGroup.md": [
		208,
		7
	],
	"./Buttons.md": [
		209,
		6
	],
	"./Card.md": [
		210,
		5
	],
	"./Carousel.md": [
		211,
		0
	],
	"./Dropdowns.md": [
		212,
		11
	],
	"./Jumbotron.md": [
		213,
		10
	],
	"./ListGroup.md": [
		214,
		9
	],
	"./Modal.md": [
		215,
		4
	],
	"./Navbar.md": [
		216,
		8
	],
	"./Navs.md": [
		217,
		3
	],
	"./Pagination.md": [
		218,
		2
	],
	"./Progress.md": [
		219,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 103;
module.exports = webpackAsyncContext;

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_toast__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_confirm__ = __webpack_require__(106);





if (false) {
  Vue.use(Vuex);
}

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex___default.a.Store({
  strict: "production" !== 'production',
  modules: {
    toast: __WEBPACK_IMPORTED_MODULE_2__modules_toast__["a" /* default */],
    confirm: __WEBPACK_IMPORTED_MODULE_3__modules_confirm__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_utils__ = __webpack_require__(13);


var state = {
  show: false,
  message: ''
};

var mutations = {
  UPDATE_TOAST: function UPDATE_TOAST(state, toastConfig) {
    Object(__WEBPACK_IMPORTED_MODULE_0__src_utils__["c" /* merge */])(state, toastConfig);
  }
};

var actions = {
  updateToast: function updateToast(_ref, toastConfig) {
    var commit = _ref.commit;

    commit('UPDATE_TOAST', toastConfig);
  }
};

var getters = {
  toast: function toast(state) {
    return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_utils__ = __webpack_require__(13);


var state = {
  show: false,
  title: '',
  content: ''
};

var mutations = {
  UPDATE_CONFIRM: function UPDATE_CONFIRM(state, confirmConfig) {
    Object(__WEBPACK_IMPORTED_MODULE_0__src_utils__["c" /* merge */])(state, confirmConfig);
  }
};

var actions = {
  updateConfirm: function updateConfirm(_ref, confirmConfig) {
    var commit = _ref.commit;

    commit('UPDATE_CONFIRM', confirmConfig);
  }
};

var getters = {
  confirm: function confirm(state) {
    return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Demo__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ComponentDoc__ = __webpack_require__(201);


// components

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1__src__["a" /* default */]);

// demo components

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component(__WEBPACK_IMPORTED_MODULE_2__components_Demo__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__components_Demo__["a" /* default */]);
// doc components

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component(__WEBPACK_IMPORTED_MODULE_3__components_ComponentDoc__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__components_ComponentDoc__["a" /* default */]);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_alert_Alert__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_badge_Badge__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_breadcrumb_Breadcrumb__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_breadcrumb_BreadcrumbItem__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_Button__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_buttons_ButtonGroup__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_buttons_ButtonGroupItem__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_card_Card__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_card_CardGroup__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_carousel_Carousel__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_carousel_CarouselItem__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_dropdowns_Dropdown__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_dropdowns_DropdownItem__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_dropdowns_divider__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_list_group_ListGroup__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_list_group_ListGroupItem__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_modal_Modal_vue__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_navs_Nav__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_navs_NavItem__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_navs_NavContent__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_navs_NavPane__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_navbar_Navbar__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_navbar_NavbarItem__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_pagination_Pagination__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_progress_Progress__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__directives_clickoutside__ = __webpack_require__(14);


// components


























// directives


var components = {
  Alert: __WEBPACK_IMPORTED_MODULE_2__components_alert_Alert__["a" /* default */],
  Badge: __WEBPACK_IMPORTED_MODULE_3__components_badge_Badge__["a" /* default */],
  Breadcrumb: __WEBPACK_IMPORTED_MODULE_4__components_breadcrumb_Breadcrumb__["a" /* default */],
  BreadcrumbItem: __WEBPACK_IMPORTED_MODULE_5__components_breadcrumb_BreadcrumbItem__["a" /* default */],
  Button: __WEBPACK_IMPORTED_MODULE_6__components_buttons_Button__["a" /* default */],
  ButtonGroup: __WEBPACK_IMPORTED_MODULE_7__components_buttons_ButtonGroup__["a" /* default */],
  ButtonGroupItem: __WEBPACK_IMPORTED_MODULE_8__components_buttons_ButtonGroupItem__["a" /* default */],
  Card: __WEBPACK_IMPORTED_MODULE_9__components_card_Card__["a" /* default */],
  CardGroup: __WEBPACK_IMPORTED_MODULE_10__components_card_CardGroup__["a" /* default */],
  Carousel: __WEBPACK_IMPORTED_MODULE_11__components_carousel_Carousel__["a" /* default */],
  CarouselItem: __WEBPACK_IMPORTED_MODULE_12__components_carousel_CarouselItem__["a" /* default */],
  Dropdown: __WEBPACK_IMPORTED_MODULE_13__components_dropdowns_Dropdown__["a" /* default */],
  DropdownItem: __WEBPACK_IMPORTED_MODULE_14__components_dropdowns_DropdownItem__["a" /* default */],
  DropdownDivider: __WEBPACK_IMPORTED_MODULE_15__components_dropdowns_divider__["a" /* default */],
  ListGroup: __WEBPACK_IMPORTED_MODULE_16__components_list_group_ListGroup__["a" /* default */],
  ListGroupItem: __WEBPACK_IMPORTED_MODULE_17__components_list_group_ListGroupItem__["a" /* default */],
  Modal: __WEBPACK_IMPORTED_MODULE_18__components_modal_Modal_vue__["a" /* default */],
  Nav: __WEBPACK_IMPORTED_MODULE_19__components_navs_Nav__["a" /* default */],
  NavItem: __WEBPACK_IMPORTED_MODULE_20__components_navs_NavItem__["a" /* default */],
  NavContent: __WEBPACK_IMPORTED_MODULE_21__components_navs_NavContent__["a" /* default */],
  NavPane: __WEBPACK_IMPORTED_MODULE_22__components_navs_NavPane__["a" /* default */],
  Navbar: __WEBPACK_IMPORTED_MODULE_23__components_navbar_Navbar__["a" /* default */],
  NavbarItem: __WEBPACK_IMPORTED_MODULE_24__components_navbar_NavbarItem__["a" /* default */],
  Pagination: __WEBPACK_IMPORTED_MODULE_25__components_pagination_Pagination__["a" /* default */],
  Progress: __WEBPACK_IMPORTED_MODULE_26__components_progress_Progress__["a" /* default */]
};

var install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(components).forEach(function (key) {
    Vue.component(components[key].name, components[key]);
  });

  Vue.directive('clickoutside', __WEBPACK_IMPORTED_MODULE_27__directives_clickoutside__["a" /* default */]);
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(components, { install: install }));

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__ = __webpack_require__(114);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_common__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-alert',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_common__["a" /* default */]],
  props: {
    closable: Boolean,
    animate: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      closed: false
    };
  },

  methods: {
    // render alert body
    generateRender: function generateRender(h) {
      var _this = this;

      // if closed, then render nothing
      if (this.closed) {
        return null;
      }
      var subComp = [this.$slots.default];
      if (this.closable) {
        subComp.unshift(h('button', {
          attrs: {
            type: 'button',
            'aria-label': 'Close'
          },
          'class': 'close',
          on: {
            click: function click() {
              _this.closed = true;
              _this.$emit('close');
            }
          }
        }, [h('span', {
          attrs: {
            'aria-hidden': 'true'
          }
        }, ['\xD7'])]));
      }
      return h('div', {
        staticClass: 'alert',
        'class': ['alert-' + this.type, { 'alert-dismissible': this.closable }],
        attrs: {
          role: 'alert'
        }
      }, subComp);
    }
  },
  render: function render(h) {
    if (this.animate) {
      // wrap with transition component
      return h('transition', {
        props: {
          leaveClass: 'show fade',
          leaveToClass: 'fade'
        }
      }, [this.generateRender(h)]);
    } else {
      return this.generateRender(h);
    }
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Badge_vue__ = __webpack_require__(116);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Badge_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_common__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-badge',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_common__["a" /* default */]],
  props: {
    pill: Boolean,
    actionable: Boolean
  },
  render: function render(h) {
    var _this = this;

    var attrs = {};
    if (this.actionable) {
      attrs.href = '#';
    }
    return h(this.actionable ? 'a' : 'span', {
      staticClass: 'badge',
      'class': ['badge-' + this.type, { 'badge-pill': this.pill }],
      attrs: attrs,
      on: {
        click: function click(e) {
          _this.$emit('click');
          e.preventDefault();
        }
      }
    }, [this.$slots.default]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f9e8dd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(119);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f9e8dd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-breadcrumb'
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BreadcrumbItem_vue__ = __webpack_require__(121);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BreadcrumbItem_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-breadcrumb-item',
  props: {
    route: [String, Object],
    href: String,
    active: Boolean
  },
  render: function render(h) {
    var attrs = {};
    if (this.active) {
      attrs['aria-current'] = 'page';
    }
    var subComp = [];
    if (!this.route && !this.href) {
      subComp.push(this.$slots.default);
    } else if (this.route) {
      subComp.push(h('router-link', { props: { to: this.route } }, [this.$slots.default]));
    } else {
      subComp.push(h('a', { attrs: { href: this.href } }, [this.$slots.default]));
    }
    return h('li', {
      staticClass: 'breadcrumb-item',
      'class': {
        active: this.active
      },
      attrs: attrs
    }, subComp);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd7b5e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(124);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd7b5e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_clickoutside__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_common__ = __webpack_require__(5);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-button',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_common__["a" /* default */]],
  props: {
    originType: {
      type: String,
      default: 'button'
    },
    outline: Boolean,
    size: String,
    block: Boolean,
    active: Boolean,
    togglable: Boolean
  },
  data: function data() {
    return {
      focus: false
    };
  },

  computed: {
    clz: function clz() {
      var list = ['btn' + (this.outline ? '-outline' : '') + '-' + this.type];
      if (this.size) {
        list.push('btn-' + this.size);
      }
      if (this.block) {
        list.push('btn-block');
      }
      if (this.focus) {
        list.push('focus');
      }
      if (this.active) {
        list.push('active');
      }
      return list;
    }
  },
  directives: {
    clickoutside: __WEBPACK_IMPORTED_MODULE_0__directives_clickoutside__["a" /* default */]
  },
  methods: {
    onClick: function onClick() {
      if (this.togglable) {
        this.focus = true;
        this.$emit('update:active', !this.active);
      }
      this.$emit('click');
    }
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (function () {
        _vm.focus = false
      }),
      expression: "()=>{focus=false}"
    }],
    ref: "button",
    staticClass: "btn",
    class: _vm.clz,
    attrs: {
      "type": _vm.originType,
      "disabled": _vm.disabled,
      "aria-pressed": _vm.active,
      "aria-disabled": _vm.disabled
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonGroup_vue__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28e90027_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonGroup_vue__ = __webpack_require__(127);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28e90027_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonGroup_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-button-group',
  props: {
    multiply: Boolean,
    type: {
      type: String,
      default: 'primary'
    },
    ariaLabel: String
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "data-toggle": "buttons",
      "aria-label": _vm.ariaLabel
    }
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonGroupItem_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0288834c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonGroupItem_vue__ = __webpack_require__(130);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonGroupItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0288834c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonGroupItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_clickoutside__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-button-item',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    checked: {
      required: true
    },
    disabled: Boolean,
    // recomment to provide
    name: {
      type: String,
      default: 'options'
    }
  },
  data: function data() {
    return {
      focus: false
    };
  },

  computed: {
    active: function active() {
      var _this = this;

      if (this.$parent.multiply) {
        return this.checked.some(function (item) {
          return item === _this.value;
        });
      } else {
        return this.checked === this.value;
      }
    }
  },
  directives: {
    clickoutside: __WEBPACK_IMPORTED_MODULE_0__directives_clickoutside__["a" /* default */]
  },
  methods: {
    onChange1: function onChange1() {
      var copy = this.checked.slice();
      if (this.active) {
        copy.splice(this.checked.indexOf(this.value), 1);
      } else {
        copy.push(this.value);
      }
      this.$emit('change', copy);
    },
    onChange2: function onChange2() {
      this.$emit('change', this.value);
    }
  }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (function () {
        _vm.focus = false
      }),
      expression: "()=>{focus=false}"
    }],
    staticClass: "btn",
    class: [("btn-" + (_vm.$parent.type)), _vm.active ? 'active' : '', _vm.focus ? 'focus' : ''],
    on: {
      "click": function($event) {
        _vm.focus = true
      }
    }
  }, [(_vm.$parent.multiply) ? [_c('input', {
    attrs: {
      "type": "checkbox",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.onChange1
    }
  }), _vm._v(" "), _vm._t("default")] : [_c('input', {
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.onChange2
    }
  }), _vm._v(" "), _vm._t("default")]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3a49b92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__(133);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3a49b92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-card',
  props: {
    imgs: {
      type: [Object, String]
    },
    headerTag: {
      type: String,
      default: 'div'
    },
    headerClass: String,
    bodyClass: String,
    footerClass: String
  },
  computed: {
    images: function images() {
      if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* isObject */])(this.imgs) && !this.imgs || Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isArray */])(this.imgs) && !this.imgs.length) {
        return null;
      }
      if (typeof this.imgs === 'string') {
        return { top: { src: this.imgs, alt: 'top-image' } };
      }
      return this.imgs;
    }
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [(_vm.$slots.header) ? _c(_vm.headerTag, {
    tag: "component",
    staticClass: "card-header",
    class: [_vm.headerClass]
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), (_vm.images && _vm.images.top) ? _c('img', {
    attrs: {
      "src": _vm.images.top.src,
      "alt": _vm.images.top.alt
    }
  }) : _vm._e(), _vm._v(" "), (_vm.images && _vm.$slots.overlay) ? _c('div', {
    staticClass: "card-img-overlay"
  }, [_vm._t("overlay")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.default) ? _c('div', {
    staticClass: "card-body",
    class: [_vm.bodyClass]
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), _vm._t("custom"), _vm._v(" "), (_vm.images && _vm.images.bottom) ? _c('img', {
    attrs: {
      "src": _vm.images.bottom.src,
      "alt": _vm.images.bottom.alt
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "card-footer",
    class: [_vm.footerClass]
  }, [_vm._t("footer")], 2) : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardGroup_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09bf5d38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CardGroup_vue__ = __webpack_require__(136);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09bf5d38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CardGroup_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-card-group',
  props: {
    deck: Boolean,
    column: Boolean
  },
  computed: {
    clz: function clz() {
      if (this.deck) {
        return 'card-deck';
      } else if (this.column) {
        return 'card-columns';
      }
      return 'card-group';
    }
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.clz]
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_689344b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Carousel_vue__ = __webpack_require__(139);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_689344b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Carousel_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-carousel',
  props: {
    showIndicators: {
      type: Boolean,
      default: true
    },
    showControl: Boolean,
    defaultActive: {
      type: Number,
      default: 0
    },
    interval: {
      type: Number,
      default: 5000
    },
    keyboard: {
      type: Boolean,
      default: true
    },
    pause: {
      type: [String, Boolean],
      default: 'hover'
    }
  },
  data: function data() {
    return {
      active: this.defaultActive,
      children: [],
      timeout: null
    };
  },

  watch: {
    active: function active(v) {
      this.$emit('change', v);
    }
  },
  methods: {
    addItem: function addItem(item) {
      this.children.push(item);
      item.init(this.children.length === this.defaultActive + 1);
    },
    removeItem: function removeItem(item) {
      this.children.splice(this.children.indexOf(item), 1);
    },
    updateActive: function updateActive(direction) {
      var _this = this;

      this.children.forEach(function (child, index) {
        child.setActive(index === _this.active, direction);
      });
    },
    toPrev: function toPrev() {
      if (this.active > 0) {
        this.stopInterval();
        this.active--;
        this.updateActive('prev');
        this.startInterval();
      }
    },
    toNext: function toNext() {
      if (this.active > this.children.length - 2) {
        this.stopInterval();
        this.active++;
        this.updateActive('next');
        this.startInterval();
      }
    },
    startInterval: function startInterval() {
      var _this2 = this;

      this.timeout = setInterval(function () {
        _this2.active = (_this2.active + 1) % _this2.children.length;
        _this2.updateActive('next');
      }, this.interval);
    },
    stopInterval: function stopInterval() {
      if (this.timeout) {
        clearInterval(this.timeout);
        this.timeout = null;
      }
    }
  },
  mounted: function mounted() {
    // this.updateActive()
    this.startInterval();
  }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel slide"
  }, [(_vm.showIndicators) ? _c('ol', {
    staticClass: "carousel-indicators"
  }, _vm._l((_vm.children.length), function(_, index) {
    return _c('li', {
      class: {
        active: _vm.active === index
      },
      on: {
        "click": function($event) {
          _vm.active = index
        }
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showControl) ? [_c('a', {
    staticClass: "carousel-control-prev",
    class: {
      disabled: _vm.active <= 0
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.toPrev
    }
  }, [_c('span', {
    staticClass: "carousel-control-prev-icon",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "carousel-control-next",
    class: {
      disabled: _vm.active >= _vm.children.length
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.toNext
    }
  }, [_c('span', {
    staticClass: "carousel-control-next-icon",
    attrs: {
      "aria-hidden": "true"
    }
  })])] : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CarouselItem_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f913aea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CarouselItem_vue__ = __webpack_require__(142);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CarouselItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f913aea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CarouselItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-carousel-item',
  data: function data() {
    return {
      active: false,
      // -1 left 0 null 1 right
      direction: '',
      order: '',
      clz: []
    };
  },

  methods: {
    init: function init(active) {
      this.active = active;
      if (active) {
        this.clz = ['active'];
      }
    },
    setActive: function setActive(active, direction) {
      this.active = active;
      this.order = direction;
      this.direction = direction === 'next' ? 'left' : 'right';
    }
  },
  created: function created() {
    this.$parent.addItem(this);
  },
  destroyed: function destroyed() {
    this.$parent.removeItem(this);
  }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": ("carousel-item-" + _vm.order),
      "enter-to-class": ("carousel-item-" + _vm.direction),
      "leave-to-class": ("active carousel-item-" + _vm.direction)
    },
    on: {
      "after-enter": function($event) {
        _vm.clz = ['active']
      },
      "after-leave": function($event) {
        _vm.clz = ['']
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "carousel-item",
    class: _vm.clz
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption"
  }, [_vm._t("caption")], 2)], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__(144);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_popper_js_dist_esm_popper_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_common__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_clickoutside__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(147);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-dropdown',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_common__["a" /* default */]],
  props: {
    label: {
      type: String,
      required: true
    },
    split: Boolean,
    size: String,
    up: Boolean,
    align: {
      type: String,
      default: 'left'
    }
  },
  data: function data() {
    return {
      expanded: false
    };
  },

  watch: {
    expanded: function expanded(v) {
      if (v) {
        new __WEBPACK_IMPORTED_MODULE_0_popper_js_dist_esm_popper_js__["a" /* default */](this.$refs.trigger, this.$refs.menu, {
          placement: this.getPlacement()
        });
      }
    }
  },
  directives: {
    clickoutside: __WEBPACK_IMPORTED_MODULE_2__directives_clickoutside__["a" /* default */]
  },
  methods: {
    getPlacement: function getPlacement() {
      var placement = __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* AttachmentMap */].BOTTOM;
      if (this.up) {
        placement = __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* AttachmentMap */].TOP;
        if (this.align === 'right') {
          placement = __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* AttachmentMap */].TOPEND;
        }
      } else if (this.align === 'right') {
        placement = __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* AttachmentMap */].BOTTOMEND;
      }
      return placement;
    }
  },
  render: function render(h) {
    var _this = this;

    var trigger = h('button', {
      staticClass: this.split ? 'btn dropdown-toggle dropdown-toggle-split' : 'btn dropdown-toggle',
      'class': ['btn-' + this.type, this.size ? 'btn-' + this.size : '', { dropup: this.up }],
      attrs: {
        type: 'button',
        'aria-haspopup': true,
        'aria-expanded': '' + this.expanded
      },
      on: {
        click: function click() {
          _this.expanded = !_this.expanded;
        }
      },
      directives: [{
        name: 'clickoutside',
        value: function value(e) {
          // FIXME: always false
          if (!e.target.contains(_this.$refs.menu)) {
            _this.expanded = false;
          }
        }
      }],
      ref: 'trigger'
    }, [this.split ? null : this.label]);
    var subComp = [h('div', {
      staticClass: 'dropdown-menu',
      'class': { show: this.expanded },
      attrs: {
        'aria-labelledby': 'dropdownMenuButton'
      },
      ref: 'menu'
    }, [this.$slots.default])];
    subComp.unshift(trigger);
    if (this.split) {
      subComp.unshift(h('button', {
        attrs: { type: 'button' },
        staticClass: 'btn',
        'class': ['btn-' + this.type, this.size ? 'btn-' + this.size : '']
      }, [this.label]));
    }
    return h('div', {
      'class': [this.up ? 'dropup' : 'dropdown', { 'btn-group': this.split }]
    }, subComp);
  }
});

/***/ }),
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttachmentMap; });
var AttachmentMap = {
  AUTO: 'auto',
  TOP: 'top-start',
  TOPEND: 'top-end',
  BOTTOM: 'bottom-start',
  BOTTOMEND: 'bottom-end'
};

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownItem_vue__ = __webpack_require__(149);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownItem_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-dropdown-item',
  props: {
    disabled: Boolean,
    tag: {
      type: String,
      default: 'a'
    }
  },
  render: function render(h) {
    var _this = this;

    var attrs = {};
    if (this.tag === 'a') {
      attrs.href = '#';
    }
    return h(this.tag, {
      staticClass: 'dropdown-item',
      'class': { disabled: this.disabled },
      attrs: attrs,
      on: {
        click: function click(e) {
          if (!_this.disabled) {
            if (_this.$parent && _this.$parent.expanded !== undefined) {
              _this.$parent.expaned = false;
            }
            _this.$emit('click');
          }
          e.preventDefault();
        }
      }
    }, [this.$slots.default]);
  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-dropdown-divider',
  render: function render(h) {
    return h('div', {
      staticClass: 'dropdown-divider'
    });
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListGroup_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a512962c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ListGroup_vue__ = __webpack_require__(153);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a512962c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ListGroup_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-list-group',
  props: {}
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list-group"
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListGroupItem_vue__ = __webpack_require__(155);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListGroupItem_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_common__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-list-group-item',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_common__["a" /* default */]],
  props: {
    active: Boolean,
    tag: {
      type: String,
      default: 'div'
    },
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClick: function onClick(e) {
      this.$emit('click');
      e.preventDefault();
    }
  },
  render: function render(h) {
    var attrs = {};
    if (this.tag === 'a') {
      attrs.href = '#';
    }
    return h(this.tag, {
      staticClass: 'list-group-item',
      'class': [{ 'list-group-item-action': ['a', 'button'].indexOf(this.tag) > -1 }, { active: this.active }, { disabled: this.disabled }, this.type ? 'list-group-item-' + this.type : ''],
      attrs: attrs,
      on: {
        click: this.onClick
      }
    }, this.$slots.default);
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a1db613_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(159);
function injectStyle (ssrContext) {
  __webpack_require__(157)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a1db613_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_clickoutside__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var ClassName = {
  OPEN: 'modal-open',
  SHOW: 'show'
};
var ESCAPE_KEYCODE = 27;
var _backdrop = void 0;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-modal',
  props: {
    size: String,
    value: Boolean,
    title: String,
    role: {
      type: String,
      default: 'dialog'
    },
    ariaLabel: String,
    backdrop: {
      type: Boolean,
      default: true
    },
    keyboard: {
      type: Boolean,
      default: true
    },
    focus: {
      type: Boolean,
      default: true
    },
    trigger: Object
  },
  data: function data() {
    return {
      show: false
    };
  },

  directives: { clickoutside: __WEBPACK_IMPORTED_MODULE_0__directives_clickoutside__["a" /* default */] },
  methods: {
    close: function close() {
      this.$emit('input', false);
      this.$emit('close');
    },
    onBackdrop: function onBackdrop() {
      if (this.backdrop) {
        this.$emit('backdrop');
        this.close();
      }
    },
    onKeyboard: function onKeyboard(evt) {
      if (evt.keyCode === ESCAPE_KEYCODE) {
        this.$emit('escape');
        this.close();
      }
    },
    _showBackdrop: function _showBackdrop() {
      document.body.appendChild(_backdrop);
      this.$nextTick(function () {
        _backdrop.classList.add(ClassName.SHOW);
      });
    },
    _hideBackdrop: function _hideBackdrop() {
      if (_backdrop) {
        _backdrop.classList.remove(ClassName.SHOW);
        document.body.removeChild(_backdrop);
      }
    },
    beforeEnter: function beforeEnter() {
      // add body class
      document.body.classList.add(ClassName.OPEN);
      this._showBackdrop();
      this.$emit('before-show');
    },
    enter: function enter() {
      this.show = true;
      // reflow
      this.$el.offsetHeight;
    },
    afterEnter: function afterEnter() {
      // FIXME:focus
      if (this.focus) {
        this.$el.focus();
      }
      this.$emit('shown');
    },
    beforeLeave: function beforeLeave() {
      this.show = false;
      this.$emit('before-hide');
    },
    afterLeave: function afterLeave() {
      this._hideBackdrop();
      document.body.classList.remove(ClassName.OPEN);
      // focus trigger
      if (this.trigger) {
        var trigger = this.trigger;
        if (!this.trigger.nodeType) {
          trigger = trigger.$el;
        }
        trigger.focus && trigger.focus();
      }
      this.$emit('hidden');
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      if (_this.keyboard) {
        window.addEventListener('keydown', _this.onKeyboard);
      }
      if (!_backdrop) {
        _backdrop = document.createElement('div');
        _backdrop.className = 'modal-backdrop fade';
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keydown', this.onKeyboard);
  }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "before-leave": _vm.beforeLeave,
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "modal fade modal-show",
    class: {
      show: _vm.show
    }
  }, [_c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (function () {
        _vm.onBackdrop()
      }),
      expression: "()=>{onBackdrop()}"
    }],
    staticClass: "modal-dialog",
    class: [_vm.size ? ("modal-" + _vm.size) : ''],
    attrs: {
      "tabindex": "-1",
      "role": _vm.role,
      "aria-labelledby": _vm.ariaLabel,
      "aria-hidden": ("" + _vm.value)
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41c8cf28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__ = __webpack_require__(162);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41c8cf28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parent__ = __webpack_require__(51);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-nav',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__parent__["a" /* default */]],
  props: {
    tab: Boolean,
    pill: Boolean,
    fill: Boolean,
    justified: Boolean
  },
  methods: {
    updateActive: function updateActive(index) {
      this.activedIndex = index;
      this.$emit('input', index);
    }
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav",
    class: {
      'nav-tabs': _vm.tab, 'nav-pills': _vm.pill, 'nav-fill': _vm.fill, 'nav-justified': _vm.justified
    }
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavItem_vue__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4a2a7c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavItem_vue__ = __webpack_require__(165);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4a2a7c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__child__ = __webpack_require__(52);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-nav-item',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__child__["a" /* default */]],
  props: {
    disabled: Boolean
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled) {
        this.$parent.updateActive(this.index);
        this.$emit('click');
      }
    }
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.selected, disabled: _vm.disabled
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClick($event)
      }
    }
  }, [_vm._t("default")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavContent_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_978163c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavContent_vue__ = __webpack_require__(168);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_978163c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavContent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parent__ = __webpack_require__(51);
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-nav-content',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__parent__["a" /* default */]],
  props: {
    // not support yet.
    animate: Boolean
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-content"
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavPane_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2a93c18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavPane_vue__ = __webpack_require__(171);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavPane_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2a93c18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavPane_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__child__ = __webpack_require__(52);
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-nav-pane',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__child__["a" /* default */]],
  props: {
    ariaLabel: String
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane",
    class: [_vm.index === _vm.$parent.activedIndex ? 'show active' : ''],
    attrs: {
      "role": "tabpanel",
      "aria-labelledby": _vm.ariaLabel
    }
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7977d677_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__(174);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7977d677_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_common__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-navbar',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_common__["a" /* default */]],
  props: {
    bg: Boolean
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-expand-lg",
    class: [("navbar-" + _vm.type), _vm.bg ? ("bg-" + _vm.type) : '']
  }, [(_vm.$slots.brand) ? _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_vm._t("brand")], 2) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarSupportedContent"
    }
  }, [(_vm.$slots.default) ? _c('ul', {
    staticClass: "navbar-nav"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), _vm._t("extra")], 2)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarSupportedContent",
      "aria-controls": "navbarSupportedContent",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavbarItem_vue__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2456ecaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavbarItem_vue__ = __webpack_require__(177);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavbarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2456ecaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavbarItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-navbar-item',
  props: {
    active: Boolean,
    disabled: Boolean,
    dropdown: Boolean
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    class: {
      active: _vm.active, dropdown: _vm.dropdown
    }
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      disabled: _vm.disabled
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._t("default")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c0014b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__(185);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c0014b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(13);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-pagination',
  props: {
    value: Number,
    pages: {
      type: Number,
      default: 0
    },
    size: String,
    showPrev: {
      type: Boolean,
      default: true
    },
    showNext: {
      type: Boolean,
      default: true
    },
    showFirst: Boolean,
    showLast: Boolean,
    prevText: {
      type: String,
      default: 'Previous'
    },
    nextText: {
      type: String,
      default: 'Next'
    },
    firstText: {
      type: String,
      default: 'Home'
    },
    lastText: {
      type: String,
      default: 'End'
    },
    desc: String,
    align: {
      type: String,
      default: 'start'
    },
    // pages limit, ensure this is odd value
    limit: {
      type: Number,
      default: -1
    },
    // heading and tail page limit
    headingLimit: {
      type: Number,
      default: 2
    }
  },
  computed: {
    prevDisabled: function prevDisabled() {
      return this.value <= 1;
    },
    nextDisabled: function nextDisabled() {
      return this.value >= this.pages;
    },
    pageQueue: function pageQueue() {
      if (this.value !== undefined && this.limit !== -1 && this.limit >= this.headingLimit * 2 + 3) {
        var offset = (this.limit - this.headingLimit * 2 - 1) / 2;
        var endIndex = this.pages - this.headingLimit + 1;
        var prevIndex = Math.max(this.headingLimit + 1, this.value - Math.floor(offset));
        var nextIndex = Math.min(endIndex - 1, this.value + Math.ceil(offset));
        var array = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* rangeArray */])(1, this.headingLimit)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* rangeArray */])(prevIndex, nextIndex)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* rangeArray */])(endIndex, this.pages)));
        if (prevIndex > this.headingLimit + 1) {
          array.splice(this.headingLimit, 0, '...');
        }
        if (nextIndex < endIndex - 1) {
          array.splice(array.length - this.headingLimit, 0, '...');
        }
        return array;
      }
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* rangeArray */])(1, this.pages)));
    }
  },
  methods: {
    prev: function prev() {
      if (!this.prevDisabled) {
        this.to(this.value - 1);
      }
    },
    to: function to(page) {
      this.$emit('input', page);
    },
    next: function next() {
      if (!this.nextDisabled) {
        this.to(this.value + 1);
      }
    }
  }
});

/***/ }),
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "aria-label": _vm.desc
    }
  }, [_c('ul', {
    staticClass: "pagination",
    class: [_vm.size ? ("pagination-" + _vm.size) : '', ("justify-content-" + _vm.align)]
  }, [(_vm.showFirst) ? _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.prevDisabled
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#",
      "aria-label": "First",
      "tabindex": _vm.prevDisabled ? -1 : 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.to(1)
      }
    }
  }, [_vm._t("first"), _vm._v(" "), (!_vm.$slots.first) ? [_vm._v(_vm._s(_vm.firstText))] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showPrev) ? _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.prevDisabled
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#",
      "aria-label": "Previous",
      "tabindex": _vm.prevDisabled ? -1 : 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.prev()
      }
    }
  }, [_vm._t("prev"), _vm._v(" "), (!_vm.$slots.prev) ? [_vm._v(_vm._s(_vm.prevText))] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageQueue), function(page) {
    return _c('li', {
      staticClass: "page-item",
      class: {
        active: _vm.value === page
      }
    }, [(page === '...') ? _c('span', {
      staticClass: "page-link"
    }, [_vm._v("...")]) : _c('a', {
      staticClass: "page-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.to(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  }), _vm._v(" "), (_vm.showNext) ? _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.nextDisabled
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#",
      "aria-label": "Next",
      "tabindex": _vm.nextDisabled ? -1 : 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.next()
      }
    }
  }, [_vm._t("next"), _vm._v(" "), (!_vm.$slots.next) ? [_vm._v(_vm._s(_vm.nextText))] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showLast) ? _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.nextDisabled
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#",
      "aria-label": "Last",
      "tabindex": _vm.nextDisabled ? -1 : 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.to(_vm.pages)
      }
    }
  }, [_vm._t("last"), _vm._v(" "), (!_vm.$slots.last) ? [_vm._v(_vm._s(_vm.lastText))] : _vm._e()], 2)]) : _vm._e()], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Progress_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73e28b57_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Progress_vue__ = __webpack_require__(188);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Progress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73e28b57_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Progress_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_common__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(13);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bs-progress',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_common__["a" /* default */]],
  props: {
    value: {
      type: [Number, String, Array],
      default: 0
    },
    striped: Boolean,
    animated: Boolean
  },
  computed: {
    values: function values() {
      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* isArray */])(this.value)) {
        return this.value.map(function (v) {
          if (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isObject */])(v)) {
            return { value: +v.value || 0, type: v.type };
          } else {
            return { value: +v || 0 };
          }
        });
      } else {
        return [{ value: +this.value, type: this.type }];
      }
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, _vm._l((_vm.values), function(progress) {
    return _c('div', {
      staticClass: "progress-bar",
      class: [progress.type ? ("bg-" + (progress.type)) : '', _vm.striped ? 'progress-bar-striped' : '', _vm.animated ? 'progress-bar-animated' : ''],
      style: ({
        width: ((progress.value) + "%")
      }),
      attrs: {
        "role": "progressbar",
        "aria-valuenow": ("" + (progress.value)),
        "aria-valuemin": 0,
        "aria-valuemax": "100"
      }
    }, [_vm._t("default")], 2)
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demo_vue__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a156c51_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Demo_vue__ = __webpack_require__(200);
function injectStyle (ssrContext) {
  __webpack_require__(190)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a156c51_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Demo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_clipboard__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'demo',
  props: {
    clz: String
  },
  data: function data() {
    return {
      show: false,
      clipboardInstance: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.clipboardInstance = new __WEBPACK_IMPORTED_MODULE_0_clipboard___default.a(_this.$refs.copy, {
        text: function text(target) {
          return target.nextElementSibling.innerText;
        }
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.clipboardInstance) {
      this.clipboardInstance.destroy();
    }
  }
});

/***/ }),
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-block",
    class: [{
      opened: _vm.show
    }, _vm.clz]
  }, [_c('div', {
    staticClass: "preview bd-example"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._t("desp"), _vm._v(" "), _c('svg', {
    staticClass: "icon-toggle-code",
    attrs: {
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('path', {
    attrs: {
      "fill": "#a8a8a8",
      "d": "M236.2 311.5 236.2 311.5c-12.5-12.5-32.8-12.5-45.3 0L9.4 493c-12.5 12.5-12.5 32.7 0 45.2l181.6 182c12.5 12.5 32.8 12.5 45.3 0l0 0c12.5-12.5 12.5-32.8 0-45.3L77.1 515.9l159.2-159.2C248.7 344.2 248.7 323.9 236.2 311.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#a8a8a8",
      "d": "M787.8 311.5 787.8 311.5c12.5-12.5 32.8-12.5 45.3 0L1014.6 493c12.5 12.5 12.5 32.7 0 45.2L833 720.3c-12.5 12.5-32.8 12.5-45.3 0l0 0c-12.5-12.5-12.5-32.8 0-45.3l159.2-159.2L787.8 356.7C775.3 344.2 775.3 323.9 787.8 311.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#a8a8a8",
      "d": "M691.2 132.1 691.2 132.1c15.6 8.2 21.6 27.6 13.4 43.2L333.5 879.2c-8.2 15.6-27.6 21.6-43.2 13.4l0 0c-15.6-8.2-21.6-27.6-13.4-43.2l371.1-703.9C656.2 129.9 675.5 123.9 691.2 132.1z"
    }
  })])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "source"
  }, [_c('span', {
    ref: "copy",
    staticClass: "btn-clipboard",
    attrs: {
      "data-original-title": "Copy to clipboard"
    }
  }, [_vm._v("Copy")]), _vm._v(" "), _vm._t("source")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentDoc_vue__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dfddf69_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentDoc_vue__ = __webpack_require__(204);
function injectStyle (ssrContext) {
  __webpack_require__(202)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentDoc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dfddf69_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentDoc_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'component-doc',
  props: {
    tabs: String
  },
  data: function data() {
    return {
      _tables: [],
      activedIndex: 1
    };
  },

  computed: {
    computedTabs: function computedTabs() {
      if (this.tabs) {
        return this.tabs.split(/,| /);
      }
      return [];
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this._tables = _this.$el.querySelectorAll('table');
      _this._tables.forEach(function (_table) {
        _table.classList.add('table');
        _table.classList.add('table-bordered');
      });
      for (var i = 0; i < _this.computedTabs.length; i++) {
        _this.$refs.pane[i].$el.appendChild(_this._tables[i]);
      }
    });
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-doc row"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('bs-nav', {
    staticClass: "flex-column",
    attrs: {
      "pill": ""
    },
    model: {
      value: (_vm.activedIndex),
      callback: function($$v) {
        _vm.activedIndex = $$v
      },
      expression: "activedIndex"
    }
  }, _vm._l((_vm.computedTabs), function(tab, index) {
    return _c('bs-nav-item', {
      key: tab
    }, [_vm._v(_vm._s(tab))])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('bs-nav-content', {
    attrs: {
      "value": _vm.activedIndex
    }
  }, _vm._l((_vm.computedTabs), function(tab, index) {
    return _c('bs-nav-pane', {
      key: tab,
      ref: "pane",
      refInFor: true
    })
  }))], 1), _vm._v(" "), _vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[53]);


// WEBPACK FOOTER //
// static/js/app.0726872fdee59622a2e5.js